import { render, staticRenderFns } from "./joinBlueSea.vue?vue&type=template&id=23ff8ab9&scoped=true&"
import script from "./joinBlueSea.vue?vue&type=script&lang=js&"
export * from "./joinBlueSea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ff8ab9",
  null
  
)

export default component.exports